module.exports = __webpack_public_path__ + "static/media/light-menuu-logo.d8396320.png";